const BaseView = require('../../components/accordion-list/content');

module.exports = BaseView.extend({
  page: 0,
  query: {
    page: 0
  },
  searchString: '',
  initialize: function () {
    this.template = require('./assetbank.hbs');
    _.bindAll(this, 'initAuthenticatedDataLoading', 'makeSearch');
    BaseView.prototype.initialize.call(this);
  },

  initDataLoading: function () {
    this.end && this.end();
    INKIVE.Modal.loader(this.$el.find('.antiscroll-inner'));
    const search = this.$el.find('#assetbank-search-input').get(0);
    const searchButton = this.$el.find('#assetbank-search-button').get(0);
    search.addEventListener('change', this.makeSearch);
    searchButton.addEventListener('click', this.makeSearch);
  },

  initAuthenticatedDataLoading: function () {
    this.authenticated = true;
    BaseView.prototype.initDataLoading.call(this);
  },

  makeSearch: function (event) {
    this.$el.find('#assetbank-search-container span').get(0).classList.remove('hidden');
    this.searchString = document.getElementById('assetbank-search-input').value.replace(' ', '+');
    this.$el.find('#assetbank-images-container div.thumbnail').remove();
    this.query.page = -1;
    this.query.term = this.searchString;
    BaseView.prototype.initDataLoading.call(this);
    this.searchKeyupEvent(event);
  },

  authenticate: function (isSearch) {
    const deferred = $.Deferred();

    this.authenticated && deferred.resolve();
    this.authenticated || window.abAsynInit(_.bind(function (success) {
      if (success) {
        isSearch || this.initAuthenticatedDataLoading();
        deferred.resolve();
      } else {
        this.trigger('no_access');
        INKIVE.Modal.loaderClose(this.$el.find('.antiscroll-inner'));
        deferred.reject();
      }
    }, this));

    return deferred.promise();
  },

  loadData: function (repeat, end) {
    this.end = end;
    this.repeat = repeat;

    INKIVE.Modal.loader(this.$el.find('.antiscroll-inner'));
    this.query.page += 1;
    this.imagesFactory.getAssetbankPhotos(this.query, this.onMoreData);
  },

  onMoreData: function (status, imagesData, data) {
    INKIVE.Modal.loaderClose(this.$el.find('.antiscroll-inner'));
    if (!status) return;

    const callback = this.tool.callbackImages.bind(this.tool);
    if (data.length >= 1) this.$el.find('#assetbank-search-container span').get(0).classList.add('hidden');
    this.tool.addThumbItem(this.$el, this.extractData(imagesData, data), callback);
    this.scrollRefresh();
    this.repeat();
  },

  getScrollHeight: function ($target) {
    const marginTop = 65;
    return $target.closest('.add').height() - marginTop;
  },

  extractData: function (imagesData, data) {
    return _.map(data, function (item) {
      return {
        id: 'photo-ab-' + item.object_id,
        src: item.src,
        data: imagesData[item.src_big]
      };
    });
  }
});
